import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiTransReportsList } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/transReports/getData', async datas => {
    const { data } = await apiTransReportsList(datas.id, datas)
    return data
})

export const transReportsSlice = createSlice({
    name: 'admin/transReports',
    initialState: {
        loading: true,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.data = []
                state.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
            })
    },
})

export const { setData, setTableData } = transReportsSlice.actions

export default transReportsSlice.reducer
